import { asiatique } from "./asiatique"
import { loveEat } from "./love-eat"
import { movieShowTime } from "./movie-show-time"
import { touristFriendly } from "./tourist-friendly"
import { emKidsAndFamily } from "./em-kids-and-family"
import { emTransportation } from "./em-transportation"
import { emBenchasiriPark } from "./em-benchasiri-park"
import { emLiveTraffic } from "./em-live-traffic"
import { emDepartmentStore } from "./em-department-store"
import { emServiceAndTourist } from "./em-service-and-tourist"
import { emCore } from "extensions/em-core"
import { emTourist } from "./em-tourist"
import { emService } from "./em-service"

export const extensionConfigs = {
  asiatique: asiatique,
  "love-eat": loveEat,
  "tourist-friendly": touristFriendly,
  "movie-show-time": movieShowTime,
  "em-live-traffic": emLiveTraffic,
  "em-transportation": emTransportation,
  "em-kids-and-family": emKidsAndFamily,
  "em-department-store": emDepartmentStore,
  "em-benchasiri-park": emBenchasiriPark,
  "em-service-and-tourist": emServiceAndTourist,
  "em-tourist": emTourist,
  "em-service": emService,
  "em-core": emCore,
}
